module.exports = __webpack_public_path__ + "logo-2.png?bce27a028443d5cdf07e005dc703704a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-2.png
// module id = 41
// module chunks = 0